<app-modal-header (closeModal)="close()" />
<app-modal-body>
  <h1 class="fw-medium fs-5 mb-3">{{ 'WHERE_WOULD_YOU_LIKE_TO_GO' | translate }}</h1>
  <div class="row">
    <div class="col-lg-12 mb-4" (click)="selectMap(map)" tabindex="0" role="button">
      <div class="card-dashed">
        <i class="ri-map-2-fill"></i>
        <p class="mb-0 mt-2">{{ map?.title }}</p>
      </div>
    </div>
    @for (item of map?.sub_maps; track $index) {
      <div class="col-4 mb-4" tabindex="0" (click)="selectMap(item)" role="button">
        <div class="card-dashed">
          <i class="ri-map-2-fill"></i>
          <p class="mb-0 mt-2">{{ item.title }}</p>
        </div>
      </div>
    }
  </div>
</app-modal-body>
